import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { extractCommonItemProps, extractProps, extractAriaProps, extractDataProps } from '../../util/layout/layoutPropsExtractor.js';
import { useAdsStylesContext } from '../../util/styles/hooks/useAdsStylesContext.js';
import { mapAdsStyles } from '../../util/styles/mapAdsStyles.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var positionPropsArray = ['position', 'top', 'bottom', 'start', 'end', 'zIndex'];
var layoutPropsArray = ['overflow', 'overflowX', 'overflowY'];
var flexBoxPropsArray = ['flexWrap', 'justifyContent', 'alignContent', 'alignItems', 'gap'];
var sizingPropsArray = ['width', 'minWidth', 'maxWidth', 'height', 'minHeight', 'maxHeight'];
function mergeStackProps(props) {
  var direction = props.direction;
  return _objectSpread(_objectSpread(_objectSpread({}, extractCommonItemProps(props)), extractProps.apply(void 0, [props].concat(sizingPropsArray, flexBoxPropsArray, layoutPropsArray, positionPropsArray))), {}, {
    display: 'flex',
    flexDirection: direction
  });
}
/**
 * The Stack component is a layout utility that organizes its child elements in a vertical column or horizontal row.
 */
var Stack = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children;
  var mergedProps = mergeStackProps(props);
  var context = useAdsStylesContext();
  var adsStyles = mapAdsStyles(mergedProps, context);
  var ariaProps = extractAriaProps(props);
  var dataProps = extractDataProps(props);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, adsStyles, ariaProps, dataProps), children);
});
Stack.displayName = 'Stack';

export { Stack };
//# sourceMappingURL=Stack.js.map
